"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPodcastShowProperty = exports.podcastShowPropertyDefinition = void 0;
exports.podcastShowPropertyDefinition = {
    view: { label: 'Show' },
    constraints: [
        {
            name: 'stencils',
            argument: ['podcast-show'],
        },
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'podcast-show',
};
const isPodcastShowProperty = (prop) => {
    return prop.name === exports.podcastShowPropertyDefinition.name;
};
exports.isPodcastShowProperty = isPodcastShowProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9kY2FzdC1zaG93LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcG9kY2FzdC1zaG93LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRTtJQUN2QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLGNBQWMsQ0FBQztTQUMzQjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxjQUFjO0NBQ1csQ0FBQTtBQUkxQixNQUFNLHFCQUFxQixHQUFHLENBQUMsSUFBa0IsRUFBK0IsRUFBRTtJQUN2RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUsscUNBQTZCLENBQUMsSUFBSSxDQUFBO0FBQ3pELENBQUMsQ0FBQTtBQUZZLFFBQUEscUJBQXFCLHlCQUVqQyJ9